<template>
  <ul class="image-row block">
    <li class="block--column" v-for="image in items" :key="image">
      <img :src="image" />
    </li>
  </ul>

</template>

<style>
.image-row li {
  margin-left: 2px;
  margin-right: 2px;
  flex: 1;
}
.image-row img {
  width: 100%;
}
</style>

<script>
export default {
  props: {
    items: Array
  }
}
</script>
